// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
.card-click-aera {
  top: 5%;
  height: 75%;
  width: 100%;
  position: absolute;
  z-index: 1;
}

.flex-auto {
  flex: 1 0 auto !important;
}

.card-header-label {
  overflow: hidden;
}

.alarmActive {
  border: 3px solid #ED6D05 !important;
}

.sensor-button {
  cursor: pointer;
  font-size: 14px;
  _margin-right: 10px;
  _margin: 0 10px;
  padding: 10px 5px 0px 5px;
}
.sensor-button.active {
  border-bottom: 3px solid #E66B00;
}

.sensor-button-text {
  max-width: 80px;
  overflow: hidden;
  _text-overflow: ellipsis;
}

.time-value {
  font-size: 12px;
  display: flex;
  flex-grow: 1;
  align-self: flex-end;
  justify-content: flex-end;
}

.device-section {
  padding: 3px 8px;
  white-space: pre;
  flex-grow: unset !important;
}

._ag-card {
  margin-bottom: 10px;
  _border: 2px solid #fff;
  border-radius: 16px;
  margin: 8px;
  overflow-y: auto;
  background-color: #fff;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
}

.device-dashboard-widget {
  border: 3px solid transparent;
  _width: 100%;
  _height: 100%;
  _border-radius: 6px;
  _background: white;
  _overflow: hidden;
  _max-height: 200px;
}
.device-dashboard-widget.ag-card {
  margin: 0;
  _margin: 10px 20px;
}

.card-container {
  flex: 1 1 0%;
  flex-direction: column;
  box-sizing: border-box;
  display: flex;
  height: 100%;
  /*position: relative;*/
}

.card-content {
  _padding: 12px 12px 2px;
  padding-top: 8px;
  padding-bottom: 8px;
  _border-bottom: 1px solid #b9b9b9;
}
.card-content .alarm-label {
  font-weight: bold;
  font-size: 16px;
  margin-right: 10px;
}
.card-content .device-label {
  flex-grow: 1;
  margin-left: 4px;
  font-size: 19px;
  font-weight: 600;
  color: #303c42;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-content .ag-device-icon {
  width: 36px;
  height: 36px;
}
.card-content .device-pic-container {
  width: 100px;
}
.card-content .device-pic-container img {
  max-height: 120px;
}
.card-content .device-pic {
  _height: 80%;
  _height: 200px;
  _padding: 15px;
  _max-height: 150px;
}
.card-content .moisture-row {
  margin: 8px;
}
.card-content .moisture-row .icon {
  width: 38px;
  height: 38px;
  margin: 0;
}
.card-content .moisture-row .moisture-value {
  margin-left: 5px;
  color: #303c42;
  height: 40px;
  font-size: 40px;
  font-weight: 500;
  line-height: 40px;
  text-align: center;
}
.card-content .moisture-crop {
  width: 100%;
  margin-left: 8px;
  overflow: hidden;
  font-size: 20px;
  color: #303c42;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ag-values-row {
  margin: 12px 0 4px 0;
  justify-content: space-evenly;
  _align-self: center;
}
.ag-values-row .ag-value-row {
  overflow: hidden;
  _width: 150px;
}
.ag-values-row .ag-value-row .icon {
  width: 32px;
  height: 32px;
  margin: 0;
}
.ag-values-row .ag-value-row .ag-value {
  _height: 32px;
  font-size: 24px;
  _line-height: 32px;
  _text-align: center;
}
.ag-values-row .ag-value-row .ag-value-label {
  font-size: 12px;
}

.ag-flot-row {
  flex-grow: 2;
  _padding-right: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/farmer-devices/farmer-device-item.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;EAAA;AAgBC;EACC,OAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EAGA,UAAA;AAFF;;AAKC;EACC,yBAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAIC;EACE,oCAAA;AADH;;AAGC;EACC,eAAA;EACC,eAAA;GAAD,kBACC;GAAD,cACC;EACA,yBAAA;AAAH;AAEG;EACC,gCAAA;AAAJ;;AAIC;EACC,eAAA;EACA,gBAAA;GADA,uBAEA;AADF;;AAIC;EACC,eAAA;EACC,aAAA;EAAe,YAAA;EAAc,oBAAA;EAC7B,yBAAA;AACH;;AAEC;EACE,gBAAA;EACA,gBAAA;EACA,2BAAA;AACH;;AAEC;EACC,mBAAA;GACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,gHAAA;AACF;;AAEC;EACC,6BAAA;GACA,WAAA;GACA,YAAA;GACA,kBAAA;GACA,iBAAA;GACA,gBAAA;GACA,iBACA;AAAF;AAEE;EACE,SAAA;GAAF,iBACE;AAAJ;;AAOA;EACE,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;AAJF;;AAMA;GAHE,sBAIA;EACA,gBAAA;EACA,mBAAA;GAHA,gCAIA;AAHF;AAKE;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;AAHJ;AAKE;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AAHJ;AAME;EACE,WAAA;EACA,YAAA;AAJJ;AAOE;EACE,YAAA;AALJ;AAMI;EAAM,iBAAA;AAHV;AAKE;GAHA,WAIE;GAHF,aAIE;GAHF,aAIE;GAHF,iBAIE;AAHJ;AAME;EACE,WAAA;AAJJ;AAMI;EACE,WAAA;EACA,YAAA;EACA,SAAA;AAJN;AAOI;EACE,gBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AALN;AASE;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;AAPJ;;AAWA;EACE,oBAAA;EACA,6BAAA;GARA,kBASA;AARF;AASE;EACE,gBAAA;GAPF,YAQE;AAPJ;AAQI;EACE,WAAA;EACA,YAAA;EACA,SAAA;AANN;AASI;GAPF,YAQI;EACA,eAAA;GAPJ,iBAQI;GAPJ,kBAQI;AAPN;AASI;EACE,eAAA;AAPN;;AAYA;EACE,YAAA;GATA,kBAUA;AATF","sourcesContent":["\r\n/**\r\n * Copyright © 2016-2020 The Thingsboard Authors\r\n *\r\n * Licensed under the Apache License, Version 2.0 (the \"License\");\r\n * you may not use this file except in compliance with the License.\r\n * You may obtain a copy of the License at\r\n *\r\n *     http://www.apache.org/licenses/LICENSE-2.0\r\n *\r\n * Unless required by applicable law or agreed to in writing, software\r\n * distributed under the License is distributed on an \"AS IS\" BASIS,\r\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\r\n * See the License for the specific language governing permissions and\r\n * limitations under the License.\r\n */\r\n\r\n .card-click-aera {\r\n  top: 5%;\r\n  height: 75%;\r\n  width: 100%;\r\n  position: absolute;\r\n  // above the card content: ion-icons create their own stacking context and would otherwise\r\n  // sit on top of this area and swallow the click\r\n  z-index: 1;\r\n }\r\n\r\n .flex-auto {\r\n  flex: 1 0 auto !important;\r\n}\r\n\r\n.card-header-label {\r\n  overflow: hidden;\r\n}\r\n .alarmActive {\r\n   border: 3px solid #ED6D05 !important;\r\n }\r\n .sensor-button {\r\n  cursor: pointer;\r\n   font-size: 14px;\r\n   _margin-right: 10px;\r\n   _margin: 0 10px;\r\n   padding: 10px 5px 0px 5px;\r\n\r\n   &.active {\r\n    border-bottom: 3px solid #E66B00;\r\n   }\r\n   \r\n }\r\n .sensor-button-text {\r\n  max-width: 80px;\r\n  overflow: hidden;\r\n  _text-overflow: ellipsis;\r\n }\r\n\r\n .time-value {\r\n  font-size: 12px;\r\n   display: flex; flex-grow: 1; align-self: flex-end;\r\n   justify-content: flex-end;\r\n }\r\n\r\n .device-section {\r\n   padding: 3px 8px;\r\n   white-space: pre;\r\n   flex-grow: unset !important;\r\n }\r\n\r\n ._ag-card {\r\n  margin-bottom: 10px;\r\n  _border: 2px solid #fff;\r\n  border-radius: 16px;\r\n  margin: 8px;\r\n  overflow-y: auto;\r\n  background-color: #fff;\r\n  box-shadow: 0 2px 4px -1px rgba(0,0,0,0.2), 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12);\r\n  \r\n }\r\n .device-dashboard-widget {\r\n  border: 3px solid transparent;\r\n  _width: 100%;\r\n  _height: 100%;\r\n  _border-radius: 6px;\r\n  _background: white;\r\n  _overflow: hidden;\r\n  \r\n  _max-height: 200px;\r\n\r\n  &.ag-card {\r\n    margin: 0;\r\n    _margin: 10px 20px;\r\n  }\r\n\r\n  \r\n}\r\n\r\n\r\n.card-container {\r\n  flex: 1 1 0%;\r\n  flex-direction: column;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  height: 100%;\r\n  /*position: relative;*/\r\n}\r\n.card-content {\r\n  _padding: 12px 12px 2px;\r\n  padding-top: 8px;\r\n  padding-bottom: 8px;\r\n  _border-bottom: 1px solid #b9b9b9;\r\n\r\n  .alarm-label {\r\n    font-weight: bold;\r\n    font-size: 16px;\r\n    margin-right: 10px;\r\n  }\r\n  .device-label {\r\n    flex-grow: 1;\r\n    margin-left: 4px;\r\n    font-size: 19px;\r\n    font-weight: 600;\r\n    color: #303c42;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n\r\n  .ag-device-icon {\r\n    width: 36px;\r\n    height: 36px;\r\n  }\r\n\r\n  .device-pic-container {\r\n    width: 100px;\r\n    img { max-height: 120px; }\r\n  }\r\n  .device-pic {\r\n    _height: 80%;\r\n    _height: 200px;\r\n    _padding: 15px;\r\n    _max-height: 150px;\r\n  }\r\n\r\n  .moisture-row {\r\n    margin: 8px;\r\n\r\n    .icon {\r\n      width: 38px;\r\n      height: 38px;\r\n      margin: 0;\r\n    }\r\n\r\n    .moisture-value {\r\n      margin-left: 5px;\r\n      color: #303c42;\r\n      height: 40px;\r\n      font-size: 40px;\r\n      font-weight: 500;\r\n      line-height: 40px;\r\n      text-align: center;\r\n    }\r\n  }\r\n\r\n  .moisture-crop {\r\n    width: 100%;\r\n    margin-left: 8px;\r\n    overflow: hidden;\r\n    font-size: 20px;\r\n    color: #303c42;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n  }\r\n}\r\n\r\n.ag-values-row {\r\n  margin: 12px 0 4px 0;\r\n  justify-content: space-evenly;\r\n  _align-self: center;\r\n  .ag-value-row {\r\n    overflow: hidden;\r\n    _width: 150px;\r\n    .icon {\r\n      width: 32px;\r\n      height: 32px;\r\n      margin: 0;\r\n    }\r\n\r\n    .ag-value {\r\n      _height: 32px;\r\n      font-size: 24px;\r\n      _line-height: 32px;\r\n      _text-align: center;\r\n    }\r\n    .ag-value-label {\r\n      font-size: 12px;\r\n    }\r\n  }\r\n}\r\n\r\n.ag-flot-row {\r\n  flex-grow: 2;\r\n  _padding-right: 8px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
